const getExplorerLink = (blockchain: string, address?: string): string => {
	const explorers: Record<string, string> = {
		TON: 'https://tonviewer.com', // TON viewer
		BSC: 'https://bscscan.com/address', // Binance Smart Chain
		'BINANCE SMART CHAIN': 'https://bscscan.com/address',
		ETH: 'https://etherscan.io/address', // Ethereum
		ETHEREUM: 'https://etherscan.io/address', // Ethereum
		POLYGON: 'https://polygonscan.com/address', // Polygon
		'POLYGON MAINNET': 'https://polygonscan.com/address',
		ARB: 'https://arbiscan.io/address', // Arbitrum
		ARBITRUM: 'https://arbiscan.io/address', // Arbitrum
		'ARBITRUM ONE': 'https://arbiscan.io/address',
		BASE: 'https://basescan.org/address', // Base
		'BASE MAINNET': 'https://basescan.org/address',
		ASSET: 'https://explorer.assetchain.org/address', // Hypothetical AssetChain explorer
		ASSETCHAIN: 'https://explorer.assetchain.org/address', // Hypothetical AssetChain explorer
	};

	let baseUrl = explorers[blockchain.toUpperCase()];
	if (!baseUrl) {
		console.warn(`Unknown blockchain: ${blockchain}`);
		return '#';
	}

	if (!address) {
		return baseUrl.replace(/\/address$/, '');
	}

	return `${baseUrl}/${address}`;
};

export default getExplorerLink;
